module.exports = __webpack_public_path__ + "static/media/compare-assessment.24a1c0e5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/compare-assessment.svg
// module id = 182
// module chunks = 0